import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrandResponse } from 'app/models/BrandResponse';
import { VariantRespDto } from 'app/models/VariantRespDto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VariantService {

  constructor(private http:HttpClient ) { }
    private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2" ;
  }
  getVariants(page: number = 0, perPage: number = 10,search : string = "", languageCode: string = 'en'): Observable<BrandResponse> {
    
    let url = `${this.apiUrl}/variants/variants?page=${page}&perPage=${perPage}`;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    return this.http.get<any>(url);
  }    
  getVariantByCode(code : string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/variants/code/${code}`);
      }
  createVariant(form: any): Observable<VariantRespDto> {
        const formData = new FormData();
      
        Object.keys(form).forEach(key => {
          const value = form[key];
          if (value !== null && value !== undefined) {
            if (value instanceof File) {
              formData.append(key, value, value.name);
            } else {
              formData.append(key, value.toString());
            }
          }
        });
      
        // 🔍 للتأكد أثناء التجربة
        formData.forEach(element=>{
      console.log(element);
        }) 
          
        
      
        return this.http.post<VariantRespDto>(
          `${this.apiUrl}/variants`,
          formData
        );
      }
  UpdateVariant(id:number,form: any): Observable<VariantRespDto> {
        const formData = new FormData();
      
        Object.keys(form).forEach(key => {
          const value = form[key];
          if (value !== null && value !== undefined) {
            if (value instanceof File) {
              formData.append(key, value, value.name);
            } else {
              formData.append(key, value.toString());
            }
          }
        });
      
        // 🔍 للتأكد أثناء التجربة
        formData.forEach(element=>{
      console.log(element);
        }) 
          
        
      
        return this.http.put<VariantRespDto>(
          `${this.apiUrl}/variants/${id}`,
          formData
        );
      }
  DeleteVariant(id:number): Observable<VariantRespDto> {
        
        return this.http.delete<VariantRespDto>(
          `${this.apiUrl}/variants/${id}`
        );
      }

}
